import Tick from "../../../../../Assets/Icons/tick-dark.svg";

const PlanCard = (props) => {
  return (
    <div className={`plan-card ${props.IsPopular ? "popular" : ""}`}>
      <section className="card-head">
        <h1>{props.Title}</h1>
        <h4>{props.Price}</h4>
      </section>
      <section className="card-content">
        {props.Content.map((Item) => {
          const hasDescription = Array.isArray(Item);
          const title = hasDescription ? Item[0] : Item;
          const description = hasDescription ? Item[1] : null;

          return (
            <span className="card-row" key={title}>
              <img alt="tick" src={Tick} />
              {description ? (
                <span className="card-row-text">
                  <p>{title}</p>
                  <p className="card-row-description">{description}</p>
                </span>
              ) : (
                <p>{title}</p>
              )}
            </span>
          );
        })}
      </section>
      {props.IsPopular ? (
        <span className="popular-sticker">Most Popular</span>
      ) : null}
    </div>
  );
};

export default PlanCard;
